import { useCallback, useMemo } from "react";
import { useDeviceType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { MonthAndDatePickerType } from "@tenant/ui";
import type { CarDateRangePickerComponentProps } from "./CarDateRangePicker";

export const useDateRangePicker = ({
  startDate,
  endDate,
  onStartDateChangeHandler,
  onEndDateChangeHandler,
  onDoneClick,
  onClose,
  dialogTitle,
  error,
}: CarDateRangePickerComponentProps) => {
  const { t } = useI18nContext();

  const { isDesktopAndUp } = useDeviceType();

  const stringStartDate = useMemo(() => {
    return startDate?.toISOString();
  }, [startDate]);

  const stringEndDate = useMemo(() => {
    return endDate?.toISOString();
  }, [endDate]);

  const onStartDateChange = useCallback(
    (date: Date | null) => {
      onStartDateChangeHandler(date ?? undefined);
    },
    [onStartDateChangeHandler]
  );

  const onEndDateChange = useCallback(
    (date: Date | null) => {
      onEndDateChangeHandler(date ?? undefined);
    },
    [onEndDateChangeHandler]
  );

  return {
    context: {
      stringStartDate,
      stringEndDate,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      dialogFullscreen: !isDesktopAndUp,
      calendarViewType: isDesktopAndUp
        ? MonthAndDatePickerType.Horizontal
        : MonthAndDatePickerType.Column,
      error,
    },
    handlers: {
      onStartDateChange,
      onEndDateChange,
      onDoneClick,
      onClose,
    },
    text: {
      startDateLabel: t("core-cars.search.pickupDate"),
      endDateLabel: t("core-cars.search.dropoffDate"),
      dialogDone: t("core-cars.search.dateApply"),
      dialogTitle,
    },
  };
};
